import React from 'react';
import SyncProgressBar from '../SyncProgressBar/SyncProgressBar';
import './MultipleSyncProgressBars.css';

const MultipleSyncProgressBars = ({
  activeSyncs = [],
  onCancel,
  onRetry,
  onHide,
  isWebSocketEnabled,
  webSocketConnectionState,
  onRetryWebSocketConnection
}) => {
  if (!activeSyncs || activeSyncs.length === 0) {
    return null;
  }

  return (
    <div className="multiple-sync-progress-container">
      {activeSyncs.map((sync) => (
        <div key={sync.boardId} className="sync-progress-row">
          <SyncProgressBar
            isVisible={sync.isVisible}
            progress={sync.progress}
            message={sync.message}
            status={sync.status}
            boardName={sync.boardName}
            waitInfo={sync.waitInfo}
            onCancel={() => onCancel(sync.boardId)}
            onRetry={() => onRetry(sync.boardId)}
            onHide={() => onHide(sync.boardId)}
            isWebSocketEnabled={isWebSocketEnabled}
            webSocketConnectionState={webSocketConnectionState}
            onRetryWebSocketConnection={onRetryWebSocketConnection}
          />
        </div>
      ))}
    </div>
  );
};

export default MultipleSyncProgressBars;
